import { render, staticRenderFns } from "./index.vue?vue&type=template&id=60d20b5d"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=60d20b5d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../prodent-web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports